exports.regexp = require('./regexp')
exports.smpp = require('./smpp')
exports.MicroCache = require('./MicroCache')
exports.schema = require('./schema')
exports.tags = require('./tags')
exports.mergeReplacingArrays = require('./mergeReplacingArrays')

const { paymentsAddCommissionToAmount } = require('@sigmasms/commons')
const { tryEachFunction, tryEachWithFunction } = require('./tryEach')
exports.tryEachFunction = tryEachFunction
exports.tryEachWithFunction = tryEachWithFunction

const no_ = require('@sigma-legacy-libs/no-lodash')
exports['no-lodash'] = no_

const cloneViaJSON = v => JSON.parse(JSON.stringify(v))
exports.cloneViaJSON = cloneViaJSON

const upgradeArray = v => (v.forEach((type, i) => v[type] = v[i]), v)
exports.upgradeArray = upgradeArray

const wait = (seconds = 5) => new Promise(resolve => setTimeout(resolve, seconds * 1000))
exports.wait = wait
const waitMs = (millisecond = 10) => new Promise(resolve => setTimeout(resolve, millisecond))
exports.waitMs = waitMs

const swapObject = object =>
  Object.keys(object).reduce((result, key) => {
    result[object[key]] = key

    return result
  }, {})
exports.swapObject = swapObject

const generateAmount = (amount, commission) => '' + paymentsAddCommissionToAmount(amount, commission)
exports.generateAmount = generateAmount
